import type { SxProps, Theme } from "@mui/material/styles";

export const categoryTagStyles = (
  theme: Theme,
): Record<string, SxProps<Theme>> => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    ml: 1.5,
  },
  colorCircle: {
    width: "26px",
    height: "26px",
    borderRadius: "4px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.common.white,
    fontWeight: "bold",
    mr: 1,
  },
});
